export const styleConfig = {
  display: { base: 'flex', md: 'none' },
};
